import React from "react";
import "../../styles/Productdetailed.css";
import ashwagandha from "../../assets/ingridients-images/shilajit/ashwagandha.png";
import safedMusli from "../../assets/ingridients-images/shilajit/safed-musli.png";
import kaunchBeej from "../../assets/ingridients-images/shilajit/kaunch-beej-extract.png";
import gokshur from "../../assets/ingridients-images/shilajit/gokshur.png";
import shilajitExtract from "../../assets/ingridients-images/shilajit/shilajit-extract.png";
import trikatu from "../../assets/ingridients-images/shilajit/trikatu.png";

const data = [
  {
    title: "Ashwagandha Extract",
    subtitle: "(Withania somnifera)",
    dosage: "90 mg",
    text: "Enhances stamina, reduces stress & supports vitality",
    image: ashwagandha,
  },
  {
    title: "Safed Musli Extract",
    subtitle: "(Asparagus adscendens)",
    dosage: "75 mg",
    text: "Boosts energy levels & supports muscle health",
    image: safedMusli,
  },
  {
    title: "Kaunch Beej Extract",
    subtitle: "(Mucuna pruriens)",
    dosage: "40 mg",
    text: "Enhances performance & endurance",
    image: kaunchBeej,
  },
  {
    title: "Gokshur",
    subtitle: "(Tribulus terrestris)",
    dosage: "40 mg",
    text: "Boosts stamina & supports muscle strength",
    image: gokshur,
  },
  {
    title: "Shilajit Extract",
    subtitle: "(Asphaltum / mineral extract)",
    dosage: "10 mg",
    text: "Rich in minerals & fulvic acid for vitality",
    image: shilajitExtract,
  },
  {
    title: "Trikatu Extract",
    subtitle: "(APM / Traditional blend)",
    dosage: "10 mg",
    text: "Aids nutrient absorption & supports digestion",
    image: trikatu,
  },
];

const ShilajitPlusIngredients = () => {
  return (
    <section className="ingredients">
      <h2 className="ingredients-title">
        Premium Ingredients for Enhanced Stamina & Vitality
      </h2>

      <div className="ingredients-grid">
        {data.map((item, index) => (
          <div className="ingredient-card" key={index}>
            <div className="pill">{item.title}</div>

            <div className="image-circle">
              <img 
                src={item.image} 
                alt={item.title}
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            </div>

            <div style={{
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#8b6f47',
              marginTop: '10px'
            }}>
              {item.dosage}
            </div>

            <p style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>{item.subtitle}</p>
            <p>{item.text}</p>
            <div className="card-shadow"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShilajitPlusIngredients;
